define.alias("shared/components/shared/ui/banner", "settings/components/shared/ui/banner");